import { useState, useEffect } from "react";

import { useDebounce } from "common/hooks/useDebounce";

export function useResponsive(mobile = 768, tablet = 1024, debounceDelay = 500) {
  const [windowSize, setWindowSize] = useState<{
    width: number;
    height: number;
  }>({
    width: window.innerWidth,
    height: window.innerHeight
  });

  const debouncedWindowSize = useDebounce(windowSize, debounceDelay) as {
    width: number;
    height: number;
  };

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };

  useEffect(() => {
    const debouncedHandleResize = handleResize;
    window.addEventListener("resize", debouncedHandleResize);

    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, []);

  const isMobile = debouncedWindowSize.width < mobile;
  const isTablet = debouncedWindowSize.width >= mobile && debouncedWindowSize.width < tablet;
  const isDesktop = debouncedWindowSize.width >= tablet;

  return { isMobile, isTablet, isDesktop };
}
